<template>
  <CustomDialog
    v-model="dialog"
    ref="customDialog"
    title="Pausa Temporária nos Sorteios Diários"
    hideFooter
    @cancel="close()"
  >
    <p>
      Para continuar oferecendo uma experiência cada vez melhor, nossos sorteios
      diários entrarão em um hiato temporário. Estamos realizando manutenções,
      otimizações e melhorias importantes para tornar a plataforma ainda mais
      segura, transparente e divertida para você.
    </p>

    <p>
      🔧 O que isso significa? <br />
      Durante esse período, novos sorteios não serão iniciados. Mas não se
      preocupe: todo o histórico, bilhetes, saldo e conquistas permanecem
      intactos.
    </p>

    <p>
      ✨ Voltaremos em breve com novidades incríveis! <br />
      Nossa equipe está trabalhando para trazer recursos novos e uma experiência
      ainda mais envolvente.
    </p>

    <p>
      Agradecemos sua compreensão e estamos ansiosos para mostrar o que vem aí.
      Fique de olho — o melhor ainda está por vir! 🚀
    </p>
  </CustomDialog>
</template>

<script>
import CustomDialog from "@/components/customDialog/CustomDialog.vue";

export default {
  name: "PausedDraw",

  components: {
    CustomDialog,
  },

  data() {
    return {
      dialog: false,
    };
  },

  methods: {
    open() {
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
